module.exports = __webpack_public_path__ + "static/media/aeromegh-logo-new.f911a352.png";